import PhysiciansSection from './PhysiciansSection';

export default PhysiciansSection;
